import { render, staticRenderFns } from "./add-edit-settings-template.vue?vue&type=template&id=d47b1074&scoped=true"
import script from "./add-edit-settings-template.vue?vue&type=script&lang=js"
export * from "./add-edit-settings-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47b1074",
  null
  
)

export default component.exports